<template>
  <!--<f7-login-screen id="my-login-screen">
  <f7-view>-->
  <f7-page login-screen class="theme-dark">
    <f7-login-screen-title class="logo padding-horizontal">
      <img :src="logo" alt />
    </f7-login-screen-title>
    <form @submit.prevent="signIn">
      <f7-list>
        <f7-list-input
          floating-label
          type="text"
          required
          validate
          name="username"
          :label="$t('LoginNameEmail')"
          :placeholder="$t('LoginNameEmail')"
          v-model:value="username"
        ></f7-list-input>
        <f7-list-input
          floating-label
          required
          validate
          :type="passwordType"
          name="password"
          :label="$t('Password')"
          :placeholder="$t('Password')"
          v-model:value="password"
        >
          <template #content-end>
            <div @click="switchVisability('passwordType')" class="margin-right link">
              <i class="f7-icons icon-view"></i>
            </div>
          </template>
        </f7-list-input>
      </f7-list>
      <f7-list>
        <f7-list-item>
          <f7-button
            type="submit"
            fill
            large
            preloader
            class="color-custom"
            :loading="isLoading"
            :class="{ disabled:isLoading }"
          >{{ $t('SignIn') }}</f7-button>
        </f7-list-item>
      </f7-list>
    </form>
  </f7-page>
  <!--  </f7-view>
  </f7-login-screen>-->
</template>


<script>
//import getDevicePushInfo from "../js/helpers/get-device-push-info";
import { f7, f7ready } from "framework7-vue";
import { HideKeyboard, CustomerTypes, getDevicePushInfo } from "../js/helpers";
import { QTAPI } from "../services/qt-api";
import { mapGetters } from "vuex";

export default {
  name: "login-screen",

  data() {
    return {
      isLoading: false,
      passwordType: "password",
      logo: "static/images/logo.svg",
      username: null,
      password: null
    };
  },
  mounted() {
    //getDevicePushInfo();
    f7ready(() => {
      //
     // var vConsole = new VConsole();
      if (localStorage.ACCOUNT && localStorage.PASSWORD) {
        this.username = localStorage.ACCOUNT;
        this.password = localStorage.PASSWORD;
        this.signIn();
      }
    });
  },
  computed: {
    ...mapGetters(["RootToken"])
  },
  methods: {
    switchVisability(name) {
      this[name] = this[name] === "password" ? "text" : "password";
    },
    async signIn() {
      getDevicePushInfo();
      const formData = {
        account: this.username,
        password: this.password,

        AppKey: !localStorage.PUSH_APP_KEY ? "123" : localStorage.PUSH_APP_KEY,
        MobileToken: !localStorage.PUSH_MOBILE_TOKEN
          ? "123"
          : localStorage.PUSH_MOBILE_TOKEN,
        DeviceToken: !localStorage.PUSH_DEVICE_TOKEN
          ? "123"
          : localStorage.PUSH_DEVICE_TOKEN,
        DeviceType: !localStorage.DEVICE_TYPE
          ? "webapp"
          : localStorage.DEVICE_TYPE
      };

      HideKeyboard();
      this.isLoading = true;
      f7.progressbar.show("green");
      const result = await QTAPI.Login(formData);
      f7.progressbar.hide();
      this.isLoading = false;
      if (!result) {
        return;
      }
      //console.log(result);
      if (
        result.UserInfo.CustomerType !== CustomerTypes.Admin &&
        result.UserInfo.CustomerType !== CustomerTypes.Agent
      ) {
        f7.dialog.alert(this.$t("AccountTypeError"), this.$t("Error"));
        return;
      }

      localStorage.ACCOUNT = formData.account;
      localStorage.PASSWORD = formData.password;

      this.$store.commit("SET_USER_INFO", result.UserInfo);
      this.$store.commit("SET_MAJOR_TOKEN", result.MajorToken);
      this.$store.commit("SET_MINOR_TOKEN", result.MinorToken);

      this.$store.commit("SET_IS_ROOT", result.MajorToken === this.RootToken);

      this.$store.commit("SET_AUTH_STATE", true);

      if (result.elemRc) {
        await this.$store.dispatch("setInStorage", {
          name: "additionalFlags",
          data: { elemRc: true }
        });
      }
      this.$store.dispatch("GetSimCommands");
      this.$store.dispatch("GetUserInfoPreEdit");
    }
  }
};
</script>

<style scoped>
</style>